import React from 'react';
import { Testimonials as TestimonialsSection, CallToAction } from '../components/Sections.jsx';

function TestimonialsPage() {
  return (
    <main>
      <TestimonialsSection />
      <CallToAction />
    </main>
  );
}

export default TestimonialsPage;






